<template>
    <div v-if="hasCombinations" class="combinations">
        <h6 class="mb-2 mt-3 font-weight-semi-bold"><b-badge pill variant="light">{{ count }}</b-badge> {{ 'combinations' | lang }}</h6>
        <div class="selectors-wrapper">
            <div class="selectors" ref="combinationReference">
                <b-button :class="{'outline-dark control left d-md-none d-flex justify-content-center':true, 'd-none': elementIsNotScrollable, 'inactive':leftIsNotScrollable}" @click="scroll(-1)">
                    <div class="d-flex align-items-center"><fa-icon icon="chevron-left"></fa-icon></div>
                </b-button>
                <b-button v-for="(combination, id) in combinations"
                    :key="id" @click="select(id)"
                    :pressed="selectedId == id"
                    variant="outline-success"
                    class="selector m-1">
                    {{ combination.combinations }}
                </b-button>
                <b-button :class="{'outline-dark control d-flex justify-content-center right d-md-none':true, 'd-none': elementIsNotScrollable, 'inactive':rightIsNotScrollable}" @click="scroll(1)">
                    <div class="d-flex align-items-center"><fa-icon icon="chevron-right"></fa-icon></div>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { createMixin } from '@tv/mixins/scroll';

export default {
    mixins: [ createMixin() ],
    props: ['gameId', 'selectedId', 'count'],
    data() {
        return {
            scrollStep: 80,
            reference: 'combinationReference',
        }
    },
    computed: {
        hasCombinations() {
            return Config.games[this.gameId].name == 'Interjackpot';
        },

        combinations() {
            if (this.gameId) {
                return Config.games[this.gameId].combinations;
            }
        },
    },
    methods: {
        select(id) {
            this.$emit('select', id);
        },
    },
    watch: {
        selectedId(val) {
            this.$nextTick(() => {
                this.selectedItemToCenter();
            });
        },
    },
}
</script>

